module.exports = __webpack_public_path__ + "static/Magic Pond - web-5e23dcb5b136d26b25331e1eb763f677.jpg";